import { Camera } from "lucide-react";
import { Photo } from "./Photo";
import { Reveal } from "./Primitives";
import { LUNA } from "@/content/content";

const Facts = () => (
  <dl className="mt-10 border-t border-white/15" data-testid="luna-facts">
    {LUNA.facts.map((f) => (
      <div key={f.k} className="flex items-baseline justify-between gap-6 border-b border-white/15 py-4">
        <dt className="text-xs font-semibold uppercase tracking-[0.2em] text-gold">{f.k}</dt>
        <dd className="text-right font-display font-bold text-paper">{f.v}</dd>
      </div>
    ))}
  </dl>
);

const Gallery = () => (
  <div className="grid grid-cols-1 gap-5 sm:grid-cols-2" data-testid="luna-gallery">
    {LUNA.gallery.map((img, i) => (
      <Photo key={img.src} image={img} ratio="aspect-[4/5]" className={i % 2 ? "sm:mt-16" : ""} testId={`luna-gallery-photo-${i + 1}`} />
    ))}
    {LUNA.gallery.length < 3 && (
      <Reveal className="flex min-h-[180px] flex-col items-start justify-end gap-3 border border-dashed border-white/25 p-6 sm:col-span-2" data-testid="luna-gallery-more">
        <Camera className="text-gold" size={24} />
        <p className="text-sm text-[#C9D4DF]">More photos of Luna will be added as her training continues.</p>
      </Reveal>
    )}
  </div>
);

export const MeetLuna = () => (
  <section id="meet-luna" className="grain relative overflow-hidden bg-navy py-24 text-paper md:py-32" data-testid="meet-luna-section">
    <span className="outline-num pointer-events-none absolute -right-6 top-6 hidden select-none md:block md:text-[18rem]" aria-hidden="true">LUNA</span>
    <div className="container-x relative grid gap-16 lg:grid-cols-[0.9fr_1.1fr] lg:gap-20">
      <Reveal className="lg:sticky lg:top-32 lg:self-start">
        <p className="eyebrow eyebrow-light">Foundation Ambassador Dog</p>
        <h2 className="mt-5 text-3xl font-extrabold leading-[1.08] tracking-tight text-paper sm:text-4xl lg:text-5xl">Meet Luna.</h2>
        <div className="mt-6 space-y-5 text-base leading-relaxed text-[#D5DEE7] md:text-lg" data-testid="luna-bio">
          {LUNA.bio.map((p) => <p key={p}>{p}</p>)}
        </div>
        <Facts />
      </Reveal>
      <Gallery />
    </div>
  </section>
);
